<template>
    <div class="materials-template">
        <Row type="flex" justify="space-between" align="middle">
            <div class="title-l">
                <router-link to="/index/materials-price" class="span-box">
                    <Icon type="ios-arrow-back" />
                    <span>询价单管理-查看</span>
                </router-link>
            </div>
        </Row>
        <div class="table-title">
            <h5>询价单信息</h5>
            <Row class="row-item">
                <Col :span="8" class="col-item">
                    <span>询价单号：</span>
                    <span>{{ form.quotationNo }}</span>
                </Col>
                <Col :span="8" class="col-item">
                    <span>询价单名称：</span>
                    <span>{{ form.name }}</span>
                </Col>
                <Col :span="8" class="col-item">
                    <span>状态：</span>
                    <span v-if="form.state === 0">未发布</span>
                    <span v-if="form.state === 1">已发布</span>
                    <span v-if="form.state === 2">已作废</span>
                </Col>
            </Row>
            <Row class="row-item">
                <Col :span="8" class="col-item">
                    <span>供应商编码：</span>
                    <span>{{ form.supplierNo }}</span>
                </Col>
                <Col :span="16" class="col-item">
                    <span>供应商名称：</span>
                    <span>{{ form.supplierName }}</span>
                </Col>
            </Row>
            <Row class="row-item">
                <Col :span="24" class="col-item">
                    <span>食堂：</span>
                    <span>{{ form.organName }}</span>
                </Col>
            </Row>
            <Row class="row-item">
                <Col :span="8" class="col-item">
                    <span>生效时间：</span>
                    <span>{{ form.startTime }}</span>
                </Col>
                <Col :span="8" class="col-item">
                    <span>结束时间：</span>
                    <span>{{ form.endTime }}</span>
                </Col>
            </Row>
            <Row class="row-item">
                <Col :span="8" class="col-item">
                    <span>创建时间：</span>
                    <span>{{ form.createdAt }}</span>
                </Col>
                <Col :span="8" class="col-item">
                    <span>更新时间：</span>
                    <span>{{ form.updatedAt }}</span>
                </Col>
            </Row>
        </div>
        <div class="table-title">
            <h5>物资信息</h5>
            <Table
                :columns="columns"
                :data="form.quotationItems"
                :height="450">
            </Table>
        </div>
        <div class="export-button" v-if="cuSupplier === 'admin1003' || cuSupplier === 'sadmin'">
            <Button type="primary" v-if="form.state === 0" @click="submit(1)">发布</Button>
            <Button v-if="form.state !== 2" @click="submit(2)">作废</Button>
        </div>
        <Modal
            v-model="tipModal"
            :title="tipModalTitle">
            <p>{{tipModalCon}}</p>
            <template slot="footer">
                <Button @click="tipModal = false">取消</Button>
                <Button type="primary" @click="submitTip" :loading="loading">确定</Button>
            </template>
        </Modal>
    </div>
</template>

<script>
import { getQuotationByQuotationNo, publishQuotation, repealQuotation } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
export default {
    data() {
        return {
            form: {},
            columns: [
                {
                    title: '序号',
                    key: 'serialCount',
                    minWidth: 100
                },
                {
                    title: '物资编码',
                    key: 'productNo',
                    minWidth: 100
                },
                {
                    title: '物资名称',
                    key: 'productName',
                    minWidth: 100
                },
                {
                    title: '物资规格',
                    key: 'productSpectype',
                    minWidth: 100
                },
                {
                    title: '物资描述',
                    key: 'productSpec',
                    minWidth: 80
                },
                {
                    title: '单价',
                    key: 'price',
                    minWidth: 100
                }
            ],
            loading: false,
            tipModal: false,
            tipModalTitle: '',
            tipModalCon: '',
            type: null,
            cuSupplier: ''
        };
    },
    mounted() {
        this.cuSupplier = Cookies.getJSON('supplierNo');
        this.getDetail();
    },
    methods: {
        submit(typ) {
            this.type = typ;
            if (typ === 1) {
                this.tipModalTitle = '发布';
                this.tipModalCon = `确定发布询价单${this.form.quotationNo}?`;
                this.tipModal = true;
            } else {
                this.tipModalTitle = '作废';
                this.tipModalCon = `确定作废询价单${this.form.quotationNo}?`;
                this.tipModal = true;
            }
        },
        submitTip() {
            if (this.type === 1) {
                // 发布
                this.loading = true;
                this.$apollo.mutate({
                    mutation: publishQuotation,
                    context: { useApi1: false },
                    variables: {
                        id: this.form.id
                    }
                }).then(res => {
                    const data = res.data.publishQuotation;
                    this.loading = false;
                    if (data && data.code === 200) {
                        this.$setNotice('发布成功');
                        this.tipModal = false;
                        this.$router.go(-1);
                    } else {
                        this.$Message.error(data.message);
                    }
                }).catch(() => {
                    this.loading = false;
                });
            } else if (this.type === 2) {
                this.loading = true;
                this.$apollo.mutate({
                    mutation: repealQuotation,
                    context: { useApi1: false },
                    variables: {
                        id: this.form.id
                    }
                }).then(res => {
                    const data = res.data.repealQuotation;
                    this.loading = false;
                    if (data && data.code === 200) {
                        this.$setNotice('作废成功');
                        this.tipModal = false;
                        this.$router.go(-1);
                    } else {
                        this.$Message.error(data.message);
                    }
                }).catch(() => {
                    this.loading = false;
                });
            }
        },
        getDetail() {
            this.$apollo.query({
                query: getQuotationByQuotationNo,
                context: { useApi1: false },
                variables: {
                    quotationNo: this.$route.query.quotationNo
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.getQuotationByQuotationNo;
                if (data && data.code === 200) {
                    this.form = data.data;
                } else {
                    this.$setNotice('详情获取失败,请重新选择');
                }
            });
        }
    }
};
</script>

<style lang="stylus" scoped>
h5
    padding: 10px;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    background: #f8f8f9;
    font-weight: 600;
    margin-bottom: 10px;
.table-title
    padding: 10px 0;
.col-item
    display: flex;
    padding: 10px 0;
    font-size: 14px;
    min-height: 40px;
    line-height: 1.5;
    span:first-child
        min-width: 100px;
        text-align: right;
.export-button
    text-align: center;
    padding: 20px 0;
    button
        width: 160px;
    button+button
        margin-left: 20px;
</style>



// WEBPACK FOOTER //
// src/views/materialsPrice/OrderDetail.vue